import { GET_VISITORS } from '../Actions/actionTypes';
const initial = {
    results: {
        Result: [],
        visitorsReceived:false
    }
};
export default (state=initial,action)=>{
    switch(action.type){
        case GET_VISITORS:
            if (action.payload.results.Result!==null && action.payload.results.ResponseCode) {
              return {...action.payload,visitorsReceived:true};
            }
            else
                return {...state,visitorsReceived:true};
        default:
            return state;
    }
}